import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import routeApi from "@/api/route";
import routeConfigApi from "@/api/setting/routeConfig";
import { toError } from "@/shared/utils/toError";
import { optimiseRoutesActions } from "./optimiseRoutesSlice";

function* handleGetRouteConfigs(action: PayloadAction<number>) {
  try {
    const { data } = yield call(routeConfigApi.getRouteConfigs, action.payload);
    yield put(optimiseRoutesActions.getRouteConfigsSuccess(data));
  } catch (error) {
    const err = toError(error);
    yield put(optimiseRoutesActions.requestFailed());
    toast.error(err.message);
  }
}

function* handleGetPlanTemplate(action: PayloadAction<number>) {
  try {
    const { data } = yield call(routeApi.getPlanTemplate, action.payload);
    yield put(optimiseRoutesActions.getPlanTemplateSuccess(data.customers));
  } catch (error) {
    const err = toError(error);
    yield put(optimiseRoutesActions.requestFailed());
    toast.error(err.message);
  }
}

function* handleSendEmail(action: PayloadAction<{ to: string; routeName: string; csvContent: string }>) {
  try {
    yield call(routeApi.sendPlanEmail, action.payload);
    yield put(optimiseRoutesActions.sendEmailSuccess());
    toast.success("Route plan sent successfully");
  } catch (error) {
    const err = toError(error);
    yield put(optimiseRoutesActions.requestFailed());
    toast.error(err.message);
  }
}

export default function* optimiseRoutesSaga() {
  yield takeLatest(optimiseRoutesActions.getRouteConfigs.type, handleGetRouteConfigs);
  yield takeLatest(optimiseRoutesActions.getPlanTemplate.type, handleGetPlanTemplate);
  yield takeLatest(optimiseRoutesActions.sendEmail.type, handleSendEmail);
}
